export default __webpack_public_path__ + "static/media/cuerpo-mujer-piel-oscura.73f1c2a3.png";